(function() {
    'use strict';

    angular
        .module('c3WebApp')
        .controller('SignRoleDeleteController',SignRoleDeleteController);

    SignRoleDeleteController.$inject = ['$uibModalInstance', 'entity', 'SignRole'];

    function SignRoleDeleteController($uibModalInstance, entity, SignRole) {
        var vm = this;

        vm.signRole = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            SignRole.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
